import { multipleSubscriptionContainer } from 'src/models'
import { specialProductTypes } from 'src/views/components/CatalogViews'

const transformCartSubscriptionProductData = subscriptionItem => {
  const mainProductSku =
    multipleSubscriptionContainer.getDefaultProductSku(subscriptionItem)
  const selectedSku = mainProductSku?.[0] || {}
  console.log('** --------- selectedSku', selectedSku)
  const skuProperties = selectedSku?.skuProperties || {}
  const { productId, skuId, type, id } = selectedSku || {}
  const isSpecialProduct = specialProductTypes.includes(type?.toLowerCase())

  const productDetails = {
    itemId: subscriptionItem?.itemId || '',
    quantity: subscriptionItem?.quantity || 1,
    unitValue: subscriptionItem?.unitValue || {},
    totalValue: subscriptionItem?.totalValue || {},
    unitPrice: subscriptionItem?.unitValue?.originalPrice || 0,
    totalPrice: subscriptionItem?.totalValue?.originalPrice || 0,
    priceAfterDiscount: subscriptionItem?.totalValue?.priceAfterDiscount || 0,
    isSubscription: subscriptionItem?.isSubscription || false,
    subscription: subscriptionItem?.subscription || {},
  }

  const skuDetails = {
    productId: productId || '',
    skuId: skuId || id || '',
    productName: skuProperties?.name || '',
    imageURL: skuProperties?.primaryimage || skuProperties?.imageURL || '',
    type,
    isSpecialProduct,
  }

  let subscriptionItemDetails = {
    ...productDetails,
    ...skuDetails,
  }

  return subscriptionItemDetails
}

export { transformCartSubscriptionProductData }
